import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "quick-scroll"
}
const _hoisted_2 = {
  class: "flex flex-wrap align-items-center scroll-mt-70 sm:mb-2 md:mb-0",
  style: {"height":"64px","margin-bottom":"9rem"},
  id: "propertyData"
}
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = {
  key: 0,
  class: "col-fixed"
}
const _hoisted_6 = {
  key: 1,
  class: "col-fixed text-right"
}
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = { class: "flex flex-row flex-wrap" }
const _hoisted_9 = { class: "col-12 xxl:col-6" }
const _hoisted_10 = { class: "card bg-compass-red" }
const _hoisted_11 = { class: "fluid grid" }
const _hoisted_12 = { class: "field col-12 md:col-6" }
const _hoisted_13 = {
  key: 0,
  class: "pi pi-lock"
}
const _hoisted_14 = {
  key: 1,
  class: "pi pi-lock-open"
}
const _hoisted_15 = { class: "field col-12 md:col-6" }
const _hoisted_16 = { class: "field col-12 md:col-8" }
const _hoisted_17 = { class: "field col-12 md:col-4" }
const _hoisted_18 = { class: "field col-12 md:col-5" }
const _hoisted_19 = { class: "field col-12 md:col-5" }
const _hoisted_20 = { class: "field col-12 md:col-2" }
const _hoisted_21 = { class: "field col-12 xl:col-8" }
const _hoisted_22 = {
  class: "mb-2",
  style: {"white-space":"nowrap"}
}
const _hoisted_23 = {
  key: 0,
  style: {"display":"inline-block"}
}
const _hoisted_24 = {
  class: "pi pi-question-circle float-right",
  style: {"font-size":"1rem","color":"white"}
}
const _hoisted_25 = { class: "field col-12 xl:col-4" }
const _hoisted_26 = {
  class: "pi pi-question-circle",
  style: {"font-size":"1rem","color":"white"}
}
const _hoisted_27 = { class: "col-12" }
const _hoisted_28 = { class: "float-right" }
const _hoisted_29 = { class: "col-12 xxl:col-6" }
const _hoisted_30 = { class: "card" }
const _hoisted_31 = { class: "fluid grid" }
const _hoisted_32 = { class: "field col-12" }
const _hoisted_33 = { class: "flex" }
const _hoisted_34 = {
  key: 0,
  class: "col-fixed"
}
const _hoisted_35 = {
  key: 2,
  class: "col-12"
}
const _hoisted_36 = { class: "card" }
const _hoisted_37 = {
  id: "propertyServiceList",
  class: "scroll-mt-70"
}
const _hoisted_38 = {
  key: 3,
  id: "documentList",
  class: "col-12 scroll-mt-70"
}
const _hoisted_39 = {
  key: 4,
  id: "ownerDetails",
  class: "col-12 scroll-mt-70"
}
const _hoisted_40 = { class: "card" }
const _hoisted_41 = { class: "grid" }
const _hoisted_42 = { class: "col" }
const _hoisted_43 = {
  key: 0,
  class: "col-fixed align-self-end align-items-center"
}
const _hoisted_44 = {
  key: 0,
  class: "pi pi-lock-open",
  style: {"font-size":"1.5rem"}
}
const _hoisted_45 = {
  key: 1,
  class: "pi pi-lock",
  style: {"font-size":"1.5rem"}
}
const _hoisted_46 = {
  key: 0,
  class: "fluid grid"
}
const _hoisted_47 = { class: "field col-12 md:col-4" }
const _hoisted_48 = { class: "field col-12 md:col-4" }
const _hoisted_49 = { class: "hidden field col-12 md:col-4" }
const _hoisted_50 = { class: "field col-12 md:col-4" }
const _hoisted_51 = {
  key: 1,
  class: "fluid grid"
}
const _hoisted_52 = {
  key: 0,
  class: "field col-12 md:col-4"
}
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 2 }
const _hoisted_55 = {
  key: 5,
  class: "flex flex-row flex-wrap scroll-mt-70",
  id: "bwofEvac"
}
const _hoisted_56 = { class: "col-12 xxl:col-6" }
const _hoisted_57 = {
  key: 0,
  class: "col-12 xxl:col-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_PropertyCustomerDetails = _resolveComponent("PropertyCustomerDetails")!
  const _component_Contacts = _resolveComponent("Contacts")!
  const _component_PropertyServiceTable = _resolveComponent("PropertyServiceTable")!
  const _component_DocumentList = _resolveComponent("DocumentList")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_PropertyBwof = _resolveComponent("PropertyBwof")!
  const _component_PropertyEvacuation = _resolveComponent("PropertyEvacuation")!
  const _component_DocumentGeneration = _resolveComponent("DocumentGeneration")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && !_ctx.newProperty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToId('#propertyData')))
          }, [...(_cache[36] || (_cache[36] = [
            _createElementVNode("span", { class: "hidden xl:block" }, "Property Details", -1),
            _createElementVNode("span", { class: "xl:hidden" }, "Property", -1)
          ]))]),
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollToId('#propertyServiceList')))
          }, "Services"),
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollToId('#documentList')))
          }, "Documents"),
          _createElementVNode("a", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollToId('#ownerDetails')))
          }, "Owner"),
          _createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scrollToId('#bwofEvac')))
          }, "Bwof")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, "Property: " + _toDisplayString(_ctx.receivedData.propertyName), 1)
      ]),
      (!_ctx.loading && _ctx.isInternalUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[37] || (_cache[37] = _createElementVNode("label", null, [
              _createTextVNode("Active"),
              _createElementVNode("br")
            ], -1)),
            _withDirectives(_createVNode(_component_InputSwitch, {
              modelValue: _ctx.receivedData.active,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.receivedData.active) = $event))
            }, null, 8, ["modelValue"]), [
              [
                _directive_tooltip,
                'Active Property',
                void 0,
                { top: true }
              ]
            ])
          ]))
        : _createCommentVNode("", true),
      (!this.newProperty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, "# " + _toDisplayString(_ctx.propertyId), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (_ctx.isInternalUser)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.enableNameEdit && _ctx.enableNameEdit(...args)))
                  }, [
                    (_ctx.nameLocked)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                      : _createCommentVNode("", true),
                    (!_ctx.nameLocked)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _cache[38] || (_cache[38] = _createElementVNode("label", null, "Property Name *", -1)),
              _createVNode(_component_InputText, {
                modelValue: _ctx.receivedData.propertyName,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.receivedData.propertyName) = $event)),
                disabled: _ctx.nameLocked
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[39] || (_cache[39] = _createElementVNode("label", null, "Building Name", -1)),
              _createVNode(_component_InputText, {
                modelValue: _ctx.receivedData.buildingName,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.receivedData.buildingName) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[40] || (_cache[40] = _createElementVNode("label", null, "Street Address *", -1)),
              _createVNode(_component_InputText, {
                modelValue: _ctx.receivedData.streetAddress,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.receivedData.streetAddress) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[41] || (_cache[41] = _createElementVNode("label", null, "Customer Property Ref #", -1)),
              _createVNode(_component_InputText, {
                modelValue: _ctx.receivedData.customerPropertyRef,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.receivedData.customerPropertyRef) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[42] || (_cache[42] = _createElementVNode("label", null, "Suburb", -1)),
              _createVNode(_component_InputText, {
                modelValue: _ctx.receivedData.suburb,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.receivedData.suburb) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[43] || (_cache[43] = _createElementVNode("label", null, "City/Town", -1)),
              _createVNode(_component_InputText, {
                modelValue: _ctx.receivedData.city,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.receivedData.city) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[44] || (_cache[44] = _createElementVNode("label", null, "Post Code", -1)),
              _createVNode(_component_InputText, {
                modelValue: _ctx.receivedData.postcode,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.receivedData.postcode) = $event))
              }, null, 8, ["modelValue"])
            ]),
            (_ctx.isInternalUser)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[47] || (_cache[47] = _createElementVNode("label", null, "Regional Authority", -1)),
                      (_ctx.receivedData.regionalAuthorityCompanyId != null && _ctx.isInternalUser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("a", {
                              class: "ml-2",
                              onClick: [
                                _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.navigation.toCompanyDetailsScreen(_ctx.receivedData.regionalAuthorityCompanyId)), ["exact"])),
                                _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.navigation.toCompanyDetailsScreen(_ctx.receivedData.regionalAuthorityCompanyId,true)), ["shift"]))
                              ]
                            }, [...(_cache[45] || (_cache[45] = [
                              _createElementVNode("i", {
                                class: "pi pi-external-link",
                                style: {"font-size":"0.75rem","color":"white"}
                              }, null, -1)
                            ]))]),
                            (_ctx.$store.getters.isInternalUser)
                              ? _withDirectives((_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "ml-3",
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toggleAuthorityEmail()))
                                }, [...(_cache[46] || (_cache[46] = [
                                  _createElementVNode("i", {
                                    class: "pi pi-envelope",
                                    style: {"font-size":"0.75rem","color":"white"}
                                  }, null, -1)
                                ]))])), [
                                  [
                                    _directive_tooltip,
                                    'Email the Regional Authority',
                                    void 0,
                                    { top: true }
                                  ]
                                ])
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("i", _hoisted_24, null, 512), [
                        [
                          _directive_tooltip,
                          'Regional Authority (Council), which also determines North Island vs South Island location of this property',
                          void 0,
                          { top: true }
                        ]
                      ])
                    ]),
                    _createVNode(_component_Multiselect, {
                      options: _ctx.authorityList,
                      searchable: true,
                      limit: 40,
                      filter: true,
                      class: "w-100pc",
                      modelValue: _ctx.receivedData.regionalAuthorityCompanyId,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.receivedData.regionalAuthorityCompanyId) = $event)),
                      valueProp: "id",
                      label: "nameAndId",
                      "track-by": "nameAndId",
                      placeholder: "Select Regional Authority"
                    }, null, 8, ["options", "modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", null, [
                      _cache[48] || (_cache[48] = _createTextVNode("Bwof Template ", -1)),
                      _withDirectives(_createElementVNode("i", _hoisted_26, null, 512), [
                        [
                          _directive_tooltip,
                          'Overrides which customer logo shows on this property BWOF. Leave empty for the Compass logo.',
                          void 0,
                          { top: true }
                        ]
                      ])
                    ]),
                    _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1)),
                    _createVNode(_component_Multiselect, {
                      options: _ctx.logoOptions,
                      searchable: true,
                      filter: true,
                      modelValue: _ctx.receivedData.bwofLogoId,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.receivedData.bwofLogoId) = $event)),
                      valueProp: "customerLogoId",
                      label: "logoName",
                      "track-by": "logoName",
                      placeholder: "(Empty for Compass)"
                    }, null, 8, ["options", "modelValue"])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("span", _hoisted_28, "Created: " + _toDisplayString(_ctx.formattedDate(_ctx.receivedData.whenCreated)), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        (_ctx.isInternalUser)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _cache[50] || (_cache[50] = _createElementVNode("label", null, "Internal Property Notes", -1)),
                    _createVNode(_component_TextArea, {
                      modelValue: _ctx.receivedData.propertyNotes,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.receivedData.propertyNotes) = $event)),
                      rows: "10",
                      autoResize: true
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _cache[51] || (_cache[51] = _createElementVNode("label", null, [
                        _createTextVNode("Enable Automation Emails"),
                        _createElementVNode("br")
                      ], -1)),
                      _createVNode(_component_InputSwitch, {
                        modelValue: _ctx.receivedData.enableEmailAutomation,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.receivedData.enableEmailAutomation) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    (!_ctx.loading && !_ctx.newProperty && _ctx.isInternalUser)
      ? (_openBlock(), _createBlock(_component_PropertyCustomerDetails, {
          key: 1,
          customerCompanyId: _ctx.receivedData.customerCompanyId,
          onUpdateCustomerCompanyId: _cache[21] || (_cache[21] = ($event: any) => {_ctx.receivedData.customerCompanyId = $event;}),
          billingEntityCompanyId: _ctx.receivedData.billingEntityCompanyId,
          onUpdateBillingEntityCompanyId: _cache[22] || (_cache[22] = ($event: any) => {_ctx.receivedData.billingEntityCompanyId = $event;}),
          receivedBillingEntity: _ctx.receivedData.billingEntity,
          onUpdateBillingEntity: _cache[23] || (_cache[23] = ($event: any) => {_ctx.receivedData.billingEntity = $event;}),
          onUpdateBillingEntityId: _cache[24] || (_cache[24] = ($event: any) => {_ctx.receivedData.billingEntityId = $event;})
        }, null, 8, ["customerCompanyId", "billingEntityCompanyId", "receivedBillingEntity"]))
      : _createCommentVNode("", true),
    (!_ctx.loading && !_ctx.newProperty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_Contacts, {
              title: "Site Contacts",
              contacts: _ctx.receivedData.siteContacts,
              view: "toggle",
              canEdit: _ctx.isInternalUser
            }, null, 8, ["contacts", "canEdit"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_37, [
      (!_ctx.loading && !_ctx.newProperty)
        ? (_openBlock(), _createBlock(_component_PropertyServiceTable, {
            key: 0,
            services: _ctx.receivedData.services,
            propertyData: _ctx.receivedData
          }, null, 8, ["services", "propertyData"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.loading && !_ctx.newProperty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          (!_ctx.loading)
            ? (_openBlock(), _createBlock(_component_DocumentList, {
                key: 0,
                propertyData: _ctx.receivedData,
                canEdit: _ctx.isInternalUser
              }, null, 8, ["propertyData", "canEdit"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && !_ctx.newProperty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("h3", null, [
                  _cache[53] || (_cache[53] = _createTextVNode(" Owner ", -1)),
                  (!_ctx.editOwnerMode && _ctx.isInternalUser && _ctx.receivedData.owner != undefined)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: [
                          _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.navigation.toCompanyDetailsScreen(_ctx.receivedData.owner.companyId)), ["exact"])),
                          _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.navigation.toCompanyDetailsScreen(_ctx.receivedData.owner.companyId)), ["shift"]))
                        ]
                      }, [...(_cache[52] || (_cache[52] = [
                        _createElementVNode("i", {
                          class: "pi pi-external-link p-1",
                          style: {"font-size":"1rem"}
                        }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.isInternalUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("a", {
                      onClick: _cache[27] || (_cache[27] = ($event: any) => {_ctx.editOwnerMode=!_ctx.editOwnerMode;})
                    }, [
                      (_ctx.editOwnerMode)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_44))
                        : _createCommentVNode("", true),
                      (!_ctx.editOwnerMode)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_45))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.receivedData.owner && !_ctx.editOwnerMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _cache[54] || (_cache[54] = _createElementVNode("label", null, "Name", -1)),
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.receivedData.owner.companyName,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.receivedData.owner.companyName) = $event)),
                      disabled: true
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _cache[55] || (_cache[55] = _createElementVNode("label", null, "Phone", -1)),
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.receivedData.owner.companyPhone,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.receivedData.owner.companyPhone) = $event)),
                      disabled: true
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _cache[56] || (_cache[56] = _createElementVNode("label", null, "Account No", -1)),
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.receivedData.owner.accountNumber,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.receivedData.owner.accountNumber) = $event)),
                      disabled: true
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _cache[57] || (_cache[57] = _createElementVNode("label", null, "City/Town", -1)),
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.receivedData.owner.city,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.receivedData.owner.city) = $event)),
                      disabled: true
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  (_ctx.editOwnerMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createVNode(_component_Dropdown, {
                          class: "flex",
                          modelValue: _ctx.selectedOwner,
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.selectedOwner) = $event)),
                          options: _ctx.ownerList,
                          placeholder: "Select Owner",
                          filter: true,
                          filterFields: ['name','id'],
                          filterPlaceholder: "Find Owner",
                          onChange: _ctx.confirmOwner
                        }, {
                          value: _withCtx((data) => [
                            (data.value.name)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(data.value.name) + " (" + _toDisplayString(data.value.id) + ")", 1))
                              : _createCommentVNode("", true)
                          ]),
                          option: _withCtx((data) => [
                            _createElementVNode("span", null, _toDisplayString(data.option.name) + " (" + _toDisplayString(data.option.id) + ")", 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "onChange"])
                      ]))
                    : _createCommentVNode("", true)
                ])),
            (!_ctx.editOwnerMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createVNode(_component_Popper, {
                    class: "popper-wrapper col-2",
                    placement: "right",
                    show: _ctx.isOwnerContactSectionTooltipShown
                  }, {
                    content: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                      _createElementVNode("div", { class: "popper-tooltip" }, "Note: No owner contact is selected to be displayed in BWOF (BWOF owner details pane)", -1)
                    ]))]),
                    default: _withCtx(() => [
                      _cache[59] || (_cache[59] = _createElementVNode("span", {
                        class: "compass-red mb-3",
                        style: {"font-size":"1rem","font-weight":"500","line-height":"1.2"}
                      }, "Owner Contacts", -1))
                    ]),
                    _: 1
                  }, 8, ["show"]),
                  _createVNode(_component_Contacts, {
                    contacts: _ctx.receivedData.ownerContacts,
                    view: "indented-list"
                  }, null, 8, ["contacts"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && !_ctx.newProperty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            (!_ctx.loading)
              ? (_openBlock(), _createBlock(_component_PropertyBwof, {
                  key: 0,
                  receivedBwofData: _ctx.receivedData.propertyBwof,
                  onUpdateBwofData: _cache[33] || (_cache[33] = ($event: any) => {_ctx.receivedData.propertyBwof = $event;}),
                  ownerContacts: _ctx.receivedData.ownerContacts
                }, null, 8, ["receivedBwofData", "ownerContacts"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isInternalUser)
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                (!_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_PropertyEvacuation, {
                      key: 0,
                      receivedEvacuationData: _ctx.receivedData.propertyEvacuation,
                      onUpdateEvacData: _cache[34] || (_cache[34] = ($event: any) => {_ctx.receivedData.propertyEvacuation = $event;})
                    }, null, 8, ["receivedEvacuationData"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDocumentGenerationComponent)
      ? (_openBlock(), _createBlock(_component_DocumentGeneration, {
          key: 6,
          selectedDocumentTemplate: _ctx.selectedDocumentTemplate,
          propertyData: _ctx.receivedData,
          recipientCompanyId: _ctx.receivedData.regionalAuthorityCompanyId,
          showDocumentPanel: false,
          onUpdateShowDocumentGenerationComponent: _cache[35] || (_cache[35] = ($event: any) => {_ctx.showDocumentGenerationComponent = $event;})
        }, null, 8, ["selectedDocumentTemplate", "propertyData", "recipientCompanyId"]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 7,
          class: "sticky-button cancel btn-fixed-width",
          icon: "pi pi-times",
          label: _ctx.hasChanges ? 'Cancel' : 'Close',
          onClick: _ctx.cancel
        }, null, 8, ["label", "onClick"]))
      : _createCommentVNode("", true),
    (!_ctx.loading && !_ctx.newProperty && _ctx.isInternalUser)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 8,
          class: "sticky-button btn-fixed-width",
          icon: "pi pi-check",
          label: "Save",
          onClick: _ctx.save,
          disabled: !_ctx.hasChanges
        }, null, 8, ["onClick", "disabled"]))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.newProperty && _ctx.isInternalUser)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 9,
          class: "sticky-button",
          icon: "pi pi-check",
          label: "Add new record",
          onClick: _ctx.saveNewProperty
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ], 64))
}